import WebFont from 'webfontloader';
import mixpanel from 'mixpanel-browser';
import { SentryWrapper } from './classes/SentryWrapper';
import { LicenseInfo } from '@mui/x-license-pro';

// Initialize Sentry
try {
    window.sentry = new SentryWrapper();
    window.sentry.init();
} catch (error) {
    console.warn('Failed to initialize Sentry:', error);
}

// Load fonts
try {
    WebFont.load({
        google: {
            families: ['Noto Sans:300,400,500,700']
        }
    });
} catch (error) {
    console.warn('Failed to load WebFonts:', error);
}

// Initialize Mixpanel
try {
    mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
    mixpanel.identify(window?.__sfdcIds?.userId);
} catch (error) {
    console.warn('Failed to initialize Mixpanel:', error);
}